import { useState } from "react";
import { Modal } from "react-bootstrap";
import ModalComponentN2 from "../../components/Modal/ModalComponentN2";

export default function TableN2IGV({ data }) {
    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    return (
        <div>
            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Genetic Maker Structural Variation</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                CHROMOSOME NO
                            </th>
                            <th scope="col" className="font-monospace">
                                POSITION
                            </th>
                            <th scope="col" className="font-monospace">
                                MARKER ID
                            </th>
                            <th scope="col" className="font-monospace">
                                REF
                            </th>
                            <th scope="col" className="font-monospace">
                                ALT
                            </th>
                            <th scope="col" className="font-monospace">
                                QUALITY
                            </th>
                            <th scope="col" className="font-monospace">
                                FILTER
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 &&
                            data.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row" className="font-monospace">
                                            {item?.chromosome_no}
                                        </th>
                                        <td className="font-monospace">{item?.position}</td>
                                        <td className="font-monospace">{item?.marker_id}</td>
                                        <td className="font-monospace">{item?.ref}</td>
                                        <td className="font-monospace">{item?.alt}</td>
                                        <td className="font-monospace">{item?.quality}</td>
                                        <td className="font-monospace">{item?.filter}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Genetic Maker Structural Variation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN2 data={dataModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
}
